__turbopack_context__.v({
  "button": "SecondaryCTA-module__rzrhIG__button",
  "buttonSpacer": "SecondaryCTA-module__rzrhIG__buttonSpacer",
  "buttons": "SecondaryCTA-module__rzrhIG__buttons",
  "prompt": "SecondaryCTA-module__rzrhIG__prompt",
  "secondaryCTA": "SecondaryCTA-module__rzrhIG__secondaryCTA",
});
